<template>
	<div style="position: relative;" class="bgg">
		<div style="text-align: center;padding-top: 5vh;">
			<img src="../assets/preview-popup-title.png" style="width: 100%;"/>
		</div>
		<div style="width: 80%;margin: 0 auto;box-sizing: border-box;margin-top: -60px;padding-top: 60px;background-color: #fff;border-radius: 20px;">
			<div style="padding: 20px 20px 0;box-sizing: border-box;">
				<div style="text-align: center;">
					<img src="../assets/invite-code.png" style="width: 45%;"/>
					<div style="font-weight: bolder;color: #f32904;font-size: 3rem;">{{jiyun_flag?invitecode:'-'}}</div>
					<div style="background-color: #ffd85c;color: #333244;font-size: 1.1rem;margin-top: 5px;height: 35px;display: flex;justify-content: center;">
						<div style="line-height: 37px;">您已获得</div><div style="padding: 0 15px;font-weight: bolder;color: #f32904;font-size: 1.7rem;padding-bottom: 2px;line-height: 35px;">{{jiyun_flag?score:'-'}}</div><div style="line-height: 37px;">积分</div>
					</div>
				</div>
				<div>
					<div style="color: #333244;font-size: 1.1rem;margin-top: 10px;">邀请语</div>
					<div style="border-radius: 10px;border: 1px solid #333244;color: #333244;font-size: 1rem;padding: 10px;box-sizing: border-box;text-align: justify;">
						<div>
							<span style="vertical-align: middle;line-height: 1.5;">我正在参加河北省新闻门户冀云客户端的读书活动，点开链接输入{{jiyun_flag?invitecode:'邀请码'}}帮我助力，一起瓜分10000元奖金。</span>
							<img @click="copy" src="../assets/copy.png" style="width: 50px;vertical-align: middle;"/>
						</div>
					</div>
				</div>
			</div>
			<div style="padding: 0 5px 20px;">
				<div style="font-size: 0.75rem;margin-top: 5px;text-align: center;">复制邀请语到微信，邀好友瓜分10000元奖金。</div>
				<div style="font-size: 0.75rem;margin-top: 5px;text-align: center;">邀请1位朋友为您助力，获取10积分，最高可得100积分</div>
			</div>
			
		</div>
		<div style="width: 80%;margin: 0 auto;padding: 20px;box-sizing: border-box;margin-top: 20px;background-color: #fff;border-radius: 20px;">
			
			<div style="text-align: center;">
				<img src="../assets/enter-invite-code.png" style="width: 75%;"/>
				<div style="display: flex;align-items: center;margin-top: 12px;">
					<input v-model="code" class="input" type="text" />
					<img @click="tijiao" src="../assets/submit-button.png" style="width: 90px;margin-left: 10px;"/>
				</div>
			</div>
		</div>
		<div v-if="loading_flag" style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 999;">
			<img src="../assets/loading.gif" style="width: 30px;position: absolute;top: 45%;left: 50%;transform: translate(-50%);" />
		</div>
		
		<div v-if="detail_flag" class="shade-view">
			<div style="text-align: left;">
				<img src="../assets/activity-details.png" style="width: 93%;padding-top: 10vh;"/>
			</div>
			<div style="text-align: center;">
				<img @click="detail_flag=false" src="../assets/back-button.png" style="width: 40%;margin-top: 20px;"/>
			</div>
		</div>
		<div v-if="rules_flag" class="shade-view">
			<div style="padding: 50px 5% 30px;">
				<div style="position: relative;padding: 20px;height: 75vh;box-sizing: border-box;background-color: #fff;border-radius: 20px;overflow-y: auto;line-height: 1.5;">
					<p style="text-autospace:ideograph-numeric;text-align:justify;text-justify:inter-ideograph">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">1. </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">活动时间</span>
					</p>
					<p style="text-align: justify; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">预热期：</span><span style="font-family:方正仿宋_GB2312">4月17日10:00 - 4月23日10:00</span></span>
					</p>
					<p style="text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">活动期：</span><span style="font-family:方正仿宋_GB2312">4月23日10:00 - 5月22日10:00</span></span>
					</p>
					<p style="text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312"><br/></span></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">2. </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">参与对象</span>
					</p>
					<p style="text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">本次活动面向冀云客户端全体注册用户，每个冀云用户仅可参与一次活动。</span>
					</p>
					<p style="text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><br/></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">3.</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">&nbsp;</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">积分规则</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">3.1</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">&nbsp;</span><span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">邀请积分：预热期间，用户邀请新用户注册并参与活动，每成功邀请</span>1人可获得</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">1</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">0积分，邀请积分上限为</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">100</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">积分</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">3.2</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">&nbsp;</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">听书积分：活动期间，用户在</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">首</span><span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">页图书广场选择有声书收听，完整播放</span>1个有声书章节即可获得20积分，章节未完播不计入积分</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">3.3 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">重复收听同一章节</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">亦可积分。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">3.4 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">用户个人总积分</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">包含</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">预热期邀请积分</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">和</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">活动期听书积分</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><br/></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">4. </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">排行榜规则</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">4.1 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">以用户总积分为排序依据，积分越高，排名越靠前</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">4.2 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">若总积分相同，优先按照活动期听书积分高低排序；若听书积分仍相同，按照达成该总积分的时间先后排序，先达成者排名靠前</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">4.3 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">排行榜</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">定期更新</span><span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">，展示前</span>100名用户的积分与排名，同时为每位用户提供个人当前排名、累计积分数据展示</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">4.4 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">活动结束，系统自动锁定所有用户的积分与排名，最终获奖排名以官方</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">公布</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">为准</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><br/></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">5. </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">兑奖规则</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">5.1 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">用户参与活动时需</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">预留</span><span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">手机号，并设置</span>6位数字领奖口令，未</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">预留</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">手机号与设置口令的用户将无法完成兑奖，视为自动放弃获奖资格</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">5.2 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">活动</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">结束</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">后，</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">工作</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">人员将通过</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">预留</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">手机号联系获奖用户，核验用户身份信息、排名信息、领奖口令，核验无误后</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">发放奖金。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><br/></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">6. 违规处理</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">6.1 任何参与活动的用户不得修改页面参数，或以任何机器人软件、爬虫软件、刷屏软件或任何非人工方式参与活动。一经发现违规或作弊行为，用户将失去参与资格。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">6.2 严禁通过侵入、攻击、篡改活动系统或其他非法技术谋取奖金。对于上述行为，活动方保留追究相应责任与赔偿的权利。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><br/></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">7. 其他说明</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">7.1 本次活动最终解释权归冀云客户端所有。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">7.2 若遇不可抗力因素导致活动无法正常进行，活动方有权调整、暂停或终止活动。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">7.3 用户参与本活动，即视为已阅读并同意本活动全部规则。</span>
					</p>
					<p>
					    <br/>
					</p>
				</div>
				<img src="../assets/rules-title.png" style="width: 50%;position: absolute;top: 10px;left: 0;"/>
			</div>
			
			<div style="text-align: center;">
				<img @click="rules_flag=false" src="../assets/back-button.png" style="width: 40%;margin-top: 0px;"/>
			</div>
		</div>
		<div class="fixed-img">
			<div>
				<img @click="detail_flag=true" src="../assets/main/details-button.png" />
			</div>
			<div>
				<img @click="rules_flag=true" src="../assets/main/rules-button.png" />
			</div>
		</div>
	</div>
</template>

<script>
	
	import Vue from 'vue';
	import Toast from 'vant/lib/toast';
	import 'vant/lib/toast/style';
	Vue.use(Toast);
	
	 import VueClipboard from 'vue-clipboard2'
	 Vue.use(VueClipboard)

	export default {
		name: 'Warm',
		components: {

		},
		data() {
			return {
				
				detail_flag:false,
				rules_flag:false,
				loading_flag:false,
				invitecode:null,
				score:null,
				contentId:'61bb64cd37cd4830bb7873b1d28bd7f8',
				code:null,
				
				jiyun_flag:false
			}
		},

		methods: {
			back(){
				this.$router.back()
			},
			tijiao(){
				
				if (this.jiyun()) {
					
					if (this.code == '' || this.code == null) {
						Toast('请填写邀请码')
						return;
					}
					let post = {
						"jytoken": window.tokenss,
						"invitecode":this.code
					}
					post = JSON.stringify(post)
					this.loading_flag = true
					this.$api.post('/yr_receive.php', {message: post}).then((data) => {
						if(data.data.code==1){
							Toast('助力成功')
							this.code=null
						}else{
							Toast(data.data.data)
						}
						this.loading_flag = false
					}).catch(() => {
						Toast('提交失败，请重试')
						this.loading_flag = false
					})
					
				}
			},
			copy(){
				var u = navigator.userAgent;
				var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
				let url = ''
				let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				if (isIOS) {
					url = 'https://jiyun-applink.hebyun.com.cn/openLink?ios_schema=jiyun://main/detail?id='+this.contentId+'&contentType=1'
				} else{
					url = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun&android_schema=jiyun%3A%2F%2Fmain%2Fdetail%3Fid%3D'+this.contentId+'%26contentType%3D1%26linkType%3D1'
				}
				let text = '我正在参加河北省新闻门户冀云客户端的读书活动，点开链接输入'+(this.jiyun_flag?this.invitecode:'邀请码')+'帮我助力，一起瓜分10000元奖金。'+url
				this.$copyText(text).then(() => {
				   Toast('文本已复制');
				}).catch(() => {
				   Toast('复制失败');
				});
			},
			jiyun() {
				var str1 = navigator.appVersion;
				var str2 = navigator.userAgent;
					
				var str = "pdmiryun";
				if (str1.indexOf(str) > -1 || str2.indexOf(str) > -1) {
					return true;
					
				} else {
					var u = navigator.userAgent;
					var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
					
					let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
					if (isIOS) {
						window.location.href = 'https://jiyun-applink.hebyun.com.cn/openLink?ios_schema=jiyun://main/detail?id='+this.contentId+'&contentType=1'
					} else{
						window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun&android_schema=jiyun%3A%2F%2Fmain%2Fdetail%3Fid%3D'+this.contentId+'%26contentType%3D1%26linkType%3D1'
					}
				}
			}
		},
		mounted() {
			var str1 = navigator.appVersion;
			var str2 = navigator.userAgent;
				
			var str = "pdmiryun";
			if (str1.indexOf(str) > -1 || str2.indexOf(str) > -1) {
				this.jiyun_flag = true
				if(window.tokenss){
					let post = {
						"jytoken": window.tokenss
					}
					post = JSON.stringify(post)
					this.$api.get('/yr_loginin.php', {
						params: {
							message: post
						}
					}).then((data) => {
						if(data.data.code==1){
							this.invitecode = data.data.data.invitecode
							this.score = data.data.data.score
						}else{
							Toast(data.data.data)
						}
						
					})
				}else{
					let timmer = setInterval(()=>{
						if(window.tokenss){
							clearInterval(timmer)
							let post = {
								"jytoken": window.tokenss
							}
							post = JSON.stringify(post)
							this.$api.get('/yr_loginin.php', {
								params: {
									message: post
								}
							}).then((data) => {
								if(data.data.code==1){
									this.invitecode = data.data.data.invitecode
									this.score = data.data.data.score
								}else{
									Toast(data.data.data)
								}
								
							})
						}
					},500)
				}
				
			}
			
			
			
			this.$api.get('/fwl.php')
			weixinshare("https://appapi.hebei.com.cn/dsrpro2026/share.png", '来冀云挑战听书擂台 瓜分万元奖金',
				'更多精彩内容，尽在冀云客户端', "https://appapi.hebei.com.cn/dsrpro2026/warm");
		}
	}
</script>

<style scoped>
	.bgg {
		background-image: url('../assets/warm-bg.png');
		background-size: 100% 100%;
		min-height: 100vh;
	}
	.input {
		width: 0;
		flex: 1;
		height: 35px;
		line-height: 35px;
		font-size: 1rem;
		background: #e4e4e4;
		outline: none;
		border: none;
		padding-left: 10px;
		
	}
	.input::placeholder{
		color: #9f9f9f;
	}
	.fixed-img {
		pointer-events: none;
		position: fixed;
		top: 25%;
		right: 0;
	}
	
	.fixed-img img {
		width: 35px;
		margin-top: 8px;
		pointer-events: visible;
	}
	.shade-view{
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 99;
		overflow-y: auto;
	}
</style>